const DATE_RANGE_WIDTH = 170;


export { DATE_RANGE_WIDTH };
